<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="closeLeadForm">
            <v-card>
                <v-card-title class="justify-center">Reopen lead</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Lead</v-col> 
                    <v-col cols=10>{{ lead.pten_code }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5" v-if="lead.pten_bedrijfsnaam!==''">
                    <v-col cols=2>Company</v-col> 
                    <v-col cols=10>{{ lead.pten_bedrijfsnaam }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Name</v-col> 
                    <v-col cols=10>{{ lead.pten_voornaam }} {{ lead.pten_naam }}</v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-5">
                    <v-col cols=4></v-col>
                    <v-col cols=4>
                        <v-select v-model="leadStatus" :items="statList" item-value="ptst_code" item-text="ptst_oms" label="Set new status" clearable dense></v-select>
                    </v-col>
                    <v-col cols=4></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="reopenLead">Save & Close</v-btn>
                    <v-btn color="primary" small @click="closeDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                lead: {},
                statList: [],
                leadStatus: "",
            }
        },
        methods: { 
            openDialog(lead, statList) {
                this.lead = lead;
                this.statList = statList;
                this.leadStatus = "";
                this.dialog = true;
            },
            reopenLead() {
                if (this.leadStatus === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "No new status selected!",
                        color: "warning",
                    }); 
                    return
                }
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus",
                    },
                    setPtenStatus: {
                        pten_encrid: this.lead.pten_encrid,
                        ptst_code: this.leadStatus,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>

